{
	"editsCopied": "Edits Copied",
	"editsPasted": "Edits Pasted",
	"redoToast": "Redo {{action}}",
	"undoToast": "Undo {{action}}"
}
